import { useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Menu } from 'primereact/menu';
import { useStore } from 'hooks/useStore';
import { useNavigate } from 'react-router-dom';

// Define the type of the component or element that `op` refers to
interface Toggleable {
  toggle: (event: React.MouseEvent) => void;
}

export const useMenuPopover = () => {
  const {
    NavbarStore: { isNavigationRestricted }
  } = useStore();
  const navigate = useNavigate();

  // Define the ref type
  const op = useRef<OverlayPanel | null>(null);
  const contextMenu = useRef<Menu | null>(null);
  const [selectedMenuItem, setSelectedMenuItem] = useState<any>(null);

  const handleMenuClick = (e: React.MouseEvent) => {
    if (op.current) {
      (op.current as any).toggle(e); // Call the `toggle` method if it exists
    }
  };

  const handleNavigation = (route: string) => {
    if (isNavigationRestricted) {
      if (window.confirm('Are you sure want to navigate??')) {
        navigate(route);
      }
    } else {
      navigate(route);
    }
  };

  const handleContextMenu = (event: React.MouseEvent, menuItem: any) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedMenuItem(menuItem);
    if (contextMenu.current) {
      contextMenu.current.show(event);
    }
  };

  const handleOpenInNewTab = () => {
    if (selectedMenuItem?.route) {
      const url = `${window.location.origin}${selectedMenuItem.route}`;
      window.open(url, '_blank');
    }
  };

  const contextMenuItems = [
    {
      label: 'Open in new tab',
      icon: 'pi pi-external-link',
      command: handleOpenInNewTab
    }
  ];

  return { 
    op, 
    handleMenuClick, 
    handleNavigation, 
    contextMenu, 
    handleContextMenu, 
    contextMenuItems 
  };
};
